export default __webpack_public_path__ + "static/media/linkedin.f74eb86e.svg";